<div class="log-viewer border-0">
  <div class="log-header bg-warning border-0">
    <div class="header-left">
      <span class="title text-dark">
        <i class="fas fa-terminal me-2"></i>
        System Logs
      </span>
      @if (isLiveMode && !isPaused) {
        <span class="badge bg-dark ms-2"
          >LIVE</span
          >
        }
        @if (isPaused) {
          <span class="badge bg-danger ms-2">PAUSED</span>
        }
      </div>
      <div class="header-center">
        <div
          class="mode-toggle btn-group shadow-sm bg-white p-1"
          style="border-radius: 6px"
          >
          <button
            class="btn btn-sm border-0 d-flex justify-content-center align-items-center"
            [style.background-color]="isLiveMode ? '#212529' : 'transparent'"
            [style.color]="isLiveMode ? '#fff' : '#212529'"
            [style.border-radius]="isLiveMode ? '4px' : ''"
            (click)="toggleLiveMode('live')"
            style="min-width: 80px"
            >
            <i class="fas fa-bolt me-1"></i> Live
          </button>
          <button
            class="btn btn-sm border-0 d-flex justify-content-center align-items-center"
            [style.background-color]="!isLiveMode ? '#212529' : 'transparent'"
            [style.color]="!isLiveMode ? '#fff' : '#212529'"
            [style.border-radius]="!isLiveMode ? '4px' : ''"
            (click)="toggleLiveMode('history')"
            style="min-width: 80px"
            >
            <i class="fas fa-history me-1"></i> History
          </button>
        </div>
      </div>
      <div class="header-right">
        @if (!isLiveMode && availableDates.length > 0) {
          <div class="date-select">
            <select
              class="form-select form-select-sm border-0 shadow-sm text-dark bg-white"
              [value]="selectedDate"
              (change)="onDateChange($event)"
              >
              @for (date of availableDates; track date) {
                <option [value]="date">
                  {{ date }}
                </option>
              }
            </select>
          </div>
        }
        <div class="search-box">
          <input
            type="text"
            class="form-control form-control-sm border-0 shadow-sm text-dark bg-white"
            placeholder="Search logs..."
            [(ngModel)]="searchTerm"
            (ngModelChange)="onSearchChange()"
            />
          @if (searchTerm) {
            <button
              class="btn-search-clear text-dark"
              (click)="clearSearch()"
              >
              <i class="fas fa-times"></i>
            </button>
          }
        </div>
        @if (isLiveMode) {
          <div class="live-controls">
            <button
              class="btn btn-sm border-0 text-dark"
              [class.bg-white]="isPaused"
              [class.shadow-sm]="isPaused"
              (click)="togglePause()"
              [title]="isPaused ? 'Resume' : 'Pause'"
              >
              <i
                class="fas"
                [class.fa-play]="isPaused"
                [class.fa-pause]="!isPaused"
              ></i>
            </button>
            <button
              class="btn btn-sm border-0 text-dark"
              [class.bg-white]="autoScroll"
              [class.shadow-sm]="autoScroll"
              (click)="toggleAutoScroll()"
              title="Auto-scroll"
              >
              <i class="fas fa-arrow-down"></i>
            </button>
          </div>
        }
        <button
          class="btn btn-sm border-0 text-danger"
          (click)="clearLogs()"
        [title]="
          isLiveMode ? 'Clear live logs' : 'Clear logs for selected date'
        "
          >
          <i class="fas fa-trash-alt"></i>
        </button>
        <button
          class="btn btn-sm border-0 text-dark"
          (click)="downloadLogs()"
          title="Download logs"
          >
          <i class="fas fa-download"></i>
        </button>
        <span class="ms-2 clickable" (click)="dialogRef.close()">
          <i
            class="fa fa-times p-2 py-1 shadow bg-light"
            style="border-radius: 5px"
          ></i>
        </span>
      </div>
    </div>

    <div class="log-content position-relative" #logContainer>
      @if (isLoading) {
        <div class="loading-overlay">
          <div class="spinner-border text-warning" role="status"></div>
          <span class="mt-2" style="font-size: 14px; font-weight: 500"
            >Fetching logs...</span
            >
          </div>
        }
        <!-- Live Mode -->
        @if (isLiveMode) {
          @if (cachedFilteredLiveLogs.length === 0) {
            <div class="empty-state">
              <i class="fas fa-rss fa-2x mb-3"></i>
              <p>Waiting for logs...</p>
              <small class="text-muted">Logs will appear here in real-time</small>
            </div>
          }
          @for (log of cachedFilteredLiveLogs; track trackByLogId($index, log)) {
            <div
              class="log-entry"
              [ngStyle]="getLiveLogStyle(log.level)"
              >
              <div class="log-meta">
                <span class="log-time">{{ log.formattedTime }}</span>
                <div class="log-indicators">
                  @if (log.count && log.count > 1) {
                    <span class="log-count-badge">{{
                      log.count
                    }}</span>
                  }
                  <span
                    class="log-source"
                    [ngClass]="'source-' + log.source?.toLowerCase()"
                    >{{ log.source }}</span
                    >
                    <span class="log-level" [ngClass]="'level-' + log.level">{{
                      log.level
                    }}</span>
                  </div>
                </div>
                <div class="log-message-container">
                  <span
                    class="log-message"
                    [class.collapsed]="log.isLong && !log.isExpanded"
                    >{{ log.message }}</span
                    >
                    @if (log.isLong) {
                      <button
                        class="btn btn-link btn-sm p-0 text-muted ms-2 toggle-btn"
                        (click)="log.isExpanded = !log.isExpanded"
                        >
                        {{ log.isExpanded ? "Show less" : "Show more" }}
                      </button>
                    }
                  </div>
                </div>
              }
            }

            <!-- History Mode -->
            @if (!isLiveMode) {
              @if (cachedFilteredHistoryLogs.length === 0) {
                <div class="empty-state">
                  <i class="fas fa-inbox fa-2x mb-3"></i>
                  <p>No logs available</p>
                  @if (searchTerm) {
                    <small class="text-muted"
                      >No matches found for "{{ searchTerm }}"</small
                      >
                    }
                  </div>
                }
                @for (item of cachedFilteredHistoryLogs; track trackByLogId($index, item)) {
                  <div
                    class="log-entry"
                    [ngStyle]="getLiveLogStyle(item.level)"
                    >
                    <div class="log-meta">
                      <span class="log-time">{{ item.formattedTime }}</span>
                      <div class="log-indicators">
                        @if (item.count && item.count > 1) {
                          <span
                            class="log-count-badge"
                            >{{ item.count }}</span
                            >
                          }
                          <span
                            class="log-source"
                            [ngClass]="'source-' + item.source?.toLowerCase()"
                            >{{ item.source }}</span
                            >
                            <span class="log-level" [ngClass]="'level-' + item.level">{{
                              item.level
                            }}</span>
                          </div>
                        </div>
                        <div class="log-message-container">
                          <span
                            class="log-message"
                            [class.collapsed]="item.isLong && !item.isExpanded"
                            [ngStyle]="getLogStyle(item.originalLine)"
                            >
                            {{ item.message }}
                          </span>
                          @if (item.isLong) {
                            <button
                              class="btn btn-link btn-sm p-0 text-muted ms-2 toggle-btn"
                              (click)="item.isExpanded = !item.isExpanded"
                              >
                              {{ item.isExpanded ? "Show less" : "Show more" }}
                            </button>
                          }
                        </div>
                      </div>
                    }
                  }
                </div>

                <div class="log-footer">
                  @if (isLiveMode) {
                    <span class="log-count">
                      {{ cachedFilteredLiveLogs.length }} entries
                      @if (searchTerm) {
                        <span> (filtered)</span>
                      }
                    </span>
                  }
                  @if (!isLiveMode) {
                    <span class="log-count">
                      {{ cachedFilteredHistoryLogs.length }} entries from {{ selectedDate }}
                    </span>
                  }
                </div>
              </div>
